/**
 * Stylized SVG wordmark logos for client showcase.
 * These are original brand-inspired wordmarks (not copies of trademarked artwork).
 * Each logo uses the client's brand color and typography style.
 */

const W = 220; // viewBox width
const H = 80;  // viewBox height

function Wordmark({ children, color = "#FFFFFF", fontSize = 26, weight = 800, letterSpacing = 0 }) {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fill={color}
        fontFamily="ui-sans-serif, system-ui, -apple-system"
        fontWeight={weight}
        fontSize={fontSize}
        letterSpacing={letterSpacing}
      >
        {children}
      </text>
    </svg>
  );
}

const ARAMCO = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <g>
      <path d="M30 50 Q40 25 50 50 T70 50" fill="none" stroke="#00843D" strokeWidth="4" strokeLinecap="round" />
      <text x="80" y="55" fill="#00843D" fontFamily="ui-sans-serif" fontWeight="800" fontSize="26" letterSpacing="1">aramco</text>
    </g>
  </svg>
);

const SABIC = () => (
  <Wordmark color="#1E5BA8" fontSize={32} weight={900} letterSpacing={2}>SABIC</Wordmark>
);

const NEOM = () => (
  <Wordmark color="#FFFFFF" fontSize={32} weight={500} letterSpacing={6}>NEOM</Wordmark>
);

const RSG = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <text x="50%" y="38" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="serif" fontWeight="400" fontSize="20" letterSpacing="3">RED SEA</text>
    <text x="50%" y="60" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="serif" fontWeight="400" fontSize="11" letterSpacing="6">GLOBAL</text>
  </svg>
);

const PIF = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <circle cx="35" cy="40" r="14" fill="none" stroke="#FFFFFF" strokeWidth="2" />
    <circle cx="35" cy="40" r="6" fill="#FFFFFF" />
    <text x="60" y="46" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="800" fontSize="22" letterSpacing="2">PIF</text>
    <text x="60" y="62" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="500" fontSize="8" letterSpacing="1" opacity="0.8">PUBLIC INVESTMENT FUND</text>
  </svg>
);

const SAUDIA = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <path d="M25 42 L45 32 L42 42 L48 42 L40 50 L30 50 Z" fill="#0E5494" />
    <text x="60" y="48" fill="#0E5494" fontFamily="ui-sans-serif" fontWeight="800" fontSize="22" letterSpacing="1">SAUDIA</text>
  </svg>
);

const KAIA = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <text x="50%" y="36" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="800" fontSize="20" letterSpacing="2">KING ABDULAZIZ</text>
    <text x="50%" y="58" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="500" fontSize="10" letterSpacing="6">INTERNATIONAL AIRPORT</text>
  </svg>
);

const RCJY = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <text x="50%" y="36" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="serif" fontWeight="700" fontSize="18" letterSpacing="2">ROYAL COMMISSION</text>
    <text x="50%" y="58" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="serif" fontWeight="500" fontSize="11" letterSpacing="4">JUBAIL · YANBU</text>
  </svg>
);

const ALRAJHI = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <rect x="30" y="32" width="16" height="16" fill="#FFFFFF" />
    <rect x="34" y="36" width="8" height="8" fill="#0E6D3F" />
    <text x="58" y="48" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="800" fontSize="22" letterSpacing="1">Al Rajhi Bank</text>
  </svg>
);

const SNB = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <text x="50%" y="34" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="800" fontSize="24" letterSpacing="3">SNB</text>
    <text x="50%" y="58" textAnchor="middle" dominantBaseline="central" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="500" fontSize="9" letterSpacing="3">Saudi National Bank</text>
  </svg>
);

const MAADEN = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <path d="M28 50 L36 30 L44 50 Z" fill="#FFFFFF" />
    <text x="58" y="48" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="800" fontSize="24" letterSpacing="2">Ma'aden</text>
  </svg>
);

const MOD = () => (
  <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <path d="M35 28 L45 36 L45 50 L35 56 L25 50 L25 36 Z" fill="none" stroke="#FFFFFF" strokeWidth="2.5" />
    <path d="M35 34 L40 38 L40 47 L35 51 L30 47 L30 38 Z" fill="#FFFFFF" opacity="0.4" />
    <text x="58" y="36" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="800" fontSize="16" letterSpacing="2">MINISTRY</text>
    <text x="58" y="58" fill="#FFFFFF" fontFamily="ui-sans-serif" fontWeight="500" fontSize="11" letterSpacing="4">OF DEFENSE</text>
  </svg>
);

export const CLIENT_LOGOS = {
  aramco: ARAMCO,
  sabic: SABIC,
  neom: NEOM,
  rsg: RSG,
  pif: PIF,
  saudia: SAUDIA,
  kaia: KAIA,
  rcjy: RCJY,
  alrajhi: ALRAJHI,
  snb: SNB,
  maaden: MAADEN,
  mod: MOD,
};

export function ClientLogo({ id, className = "" }) {
  const Comp = CLIENT_LOGOS[id];
  if (!Comp) return null;
  return (
    <div className={className} data-testid={`client-logo-${id}`}>
      <Comp />
    </div>
  );
}
